import useAudioPlayerStore from '@/client/stores/useAudioPlayerStore';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import React, { useEffect, useState } from 'react';

interface TimeDisplayProps {
  className?: ClassValue;
}

export function TimeDisplay({ className }: TimeDisplayProps) {
  const { player } = useAudioPlayerStore();
  const [time, setTime] = useState(0);

  useEffect(() => {
    player.appendOnTimeUpdateCallback(setTime);
    return () => player.removeOnTimeUpdateCallback(setTime);
  }, [player]);

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };
  return <div className={cn('text-sm text-black dark:text-white', className)}>{formatTime(time)}</div>;
}
